import { useMutation } from "@tanstack/react-query";
import { logout, type LogoutResponse } from "../api/logout";

export const useLogout = () => {
  return useMutation<LogoutResponse, Error, void>({
    mutationFn: logout,
  });
};
